import { render, staticRenderFns } from "./MyDrawer.vue?vue&type=template&id=4f48e5ca&scoped=true&"
import script from "./MyDrawer.vue?vue&type=script&lang=js&"
export * from "./MyDrawer.vue?vue&type=script&lang=js&"
import style0 from "./MyDrawer.vue?vue&type=style&index=0&id=4f48e5ca&scoped=true&lang=css&"
import style1 from "./MyDrawer.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f48e5ca",
  null
  
)

export default component.exports